import Vue from 'vue'
import VueRouter from 'vue-router'
import QRCodePage from '../views/QRCodePage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/pages/qrcode' // 默认重定向到二维码页面
  },
  {
    path: '/pages/qrcode',
    name: 'QRCode',
    component: QRCodePage
  }
]

const router = new VueRouter({
  mode: 'hash', // 使用hash模式，确保/#/pages/qrcode路径可用
  base: process.env.BASE_URL,
  routes
})

export default router 